import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';

var ModalSlider = /*#__PURE__*/function (_React$Component) {
  _inherits(ModalSlider, _React$Component);

  var _super = _createSuper(ModalSlider);

  function ModalSlider(props) {
    var _this;

    _classCallCheck(this, ModalSlider);

    _this = _super.call(this, props);
    _this.renderCloseDiv = _this.renderCloseDiv.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ModalSlider, [{
    key: "renderCloseDiv",
    value: function renderCloseDiv() {
      if (this.props.close) {
        return /*#__PURE__*/React.createElement("a", {
          href: "#",
          onClick: this.props.close,
          style: this.props.closeStyle
        }, this.props.closeText || 'Close');
      }
    }
  }, {
    key: "calculateSlidingStyle",
    value: function calculateSlidingStyle() {
      var oneHundred = 110;

      switch (this.props.slideFrom) {
        case 'left':
          oneHundred *= -1;

        case 'right':
          return {
            hidden: {
              marginLeft: "".concat(oneHundred, "%"),
              visibility: 'hidden'
            },
            shown: {
              marginLeft: '0%',
              visibility: ''
            }
          };

        case 'top':
          oneHundred *= -1;

        case 'bottom':
        default:
          return {
            hidden: {
              marginTop: "".concat(oneHundred, "%"),
              visibility: 'hidden'
            },
            shown: {
              marginTop: '0%',
              visibility: ''
            }
          };
      }
    }
  }, {
    key: "calculateOuterStyle",
    value: function calculateOuterStyle() {
      var overlayStyle = {
        minWidth: '100%',
        minHeight: '100%',
        overflowY: 'auto',
        // to be checked
        overflowX: 'hidden',
        // to be checked
        position: 'fixed',
        background: '#000',
        boxShadow: '0px 2px 4px 0px rgba(0,0,0,0.3)',
        left: 0,
        WebkitTransition: 'all 500ms ease',
        MozTransition: 'all 500ms ease',
        OTransition: 'all 500ms ease',
        transition: 'all 500ms ease',
        top: 70,
        willChange: 'transform'
      };
      var defaultStyle = {
        backgroundColor: 'rgb(255,255,255,0.5)',
        zIndex: '2'
      };

      var _ref = this.props.customStyle || defaultStyle,
          backgroundColor = _ref.backgroundColor,
          zIndex = _ref.zIndex;

      var behaviour = this.calculateSlidingStyle();
      var shownStyle = Object.assign({}, overlayStyle, behaviour.shown, {
        backgroundColor: backgroundColor,
        zIndex: zIndex
      });
      var hiddenStyle = Object.assign({}, overlayStyle, behaviour.hidden, {
        backgroundColor: backgroundColor,
        zIndex: zIndex
      });
      return this.props.show ? shownStyle : hiddenStyle;
    }
  }, {
    key: "calculateInnerStyle",
    value: function calculateInnerStyle() {
      var centered = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
      };
      return this.props.innerStyle || centered;
    }
  }, {
    key: "render",
    value: function render() {
      // extract only styles that are needed
      var outerStyle = this.calculateOuterStyle();
      var innerStyle = this.calculateInnerStyle();
      var closeDiv = this.renderCloseDiv();
      return /*#__PURE__*/React.createElement("div", {
        style: outerStyle
      }, closeDiv, this.props.children);
    }
  }]);

  return ModalSlider;
}(React.Component);

ModalSlider.propTypes = {
  close: PropTypes.func,
  closeStyle: PropTypes.object,
  closeText: PropTypes.string,
  customStyle: PropTypes.object,
  innerStyle: PropTypes.object,
  show: PropTypes.bool.isRequired,
  slideFrom: PropTypes.oneOf(['right', 'bottom', 'left', 'top'])
};
ModalSlider.defaultProps = {
  close: undefined,
  closeStyle: undefined,
  closeText: '',
  customStyle: undefined,
  innerStyle: undefined,
  show: false,
  slideFrom: 'bottom'
};
export default ModalSlider;